var React = require('react');

function SubtractOrange (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FF913A","fillRule":"evenodd","d":"M27.69 54.73c14.888 0 26.959-12.07 26.959-26.96 0-14.889-12.07-26.96-26.96-26.96S.73 12.882.73 27.77c0 .158.002.316.005.473h26.482v26.483c.158.002.315.004.473.004Z","clipRule":"evenodd"}));
}

SubtractOrange.defaultProps = {"width":"55","height":"55","fill":"none","viewBox":"0 0 55 55"};

module.exports = SubtractOrange;

SubtractOrange.default = SubtractOrange;
